<template src="./TarjetasEsquemas.html"></template> 

<script>
import {
  createScheme,
  getScheme,
  updateScheme,
} from "../../../../apiService/request/CrudTerapias";
import moment from "moment";
moment.locale("es");
export default {
  name: "tarjetas-esquemas",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      reglaObligatorio: [(v) => !!v || "Campo obligatorio"],
      schemeName: null,
      createValid: false,
      keyFormCreate: 0,
      sessionItems: [], // {nombre_sesion: null, iconoUrl: '', index: 0}
      prueba: null,
      schemeToEdit: [],
      newSessionItems: [],
    };
  },
  props: {
    schemesItems: {
      type: Array,
      default: () => [],
    },
    therapyName: {
      type: String,
      default: "",
    },
  },
  methods: {
    async createSchemeWidth() {
      if (this.$refs.formCreate.validate()) {
        console.log("Creando esquema ...");
        try {
          this.$store.dispatch("setCargando", true);
          const sessionsMapped = this.sessionItems.map((val, index) => {
            return {
              nombre_sesion: val.nombre_sesion,
              iconoUrl: val.iconoUrl,
              index_sesion: index,
            };
          });
          const respuesta = await createScheme(
            this.$store.state.provider_email,
            this.therapyName,
            this.schemeName,
            sessionsMapped
          );
          if (respuesta && respuesta.data && respuesta.data.data) {
            this.$emit("schemeCreated");
            this.resetForm();
          }
        } catch (err) {
          console.log(err);
        } finally {
          this.$store.dispatch("setCargando", false);
        }
      } else {
        console.log("Datos incompletos para la creación");
      }
    },
    resetForm() {
      this.sessionItems = [];
      this.newSessionItems = [];
      this.schemeToEdit = [];
      this.$refs.formCreate.reset();
      this.createDialog = false;
      this.editDialog = false;
    },
    addSession() {
      const copia = this.sessionItems;
      copia.push({
        nombre_sesion: null,
        iconoUrl: "",
        index_sesion: copia.length,
      });
      this.sessionItems = [...copia];
      this.scrollAddSession();
    },
    scrollAddSession() {
      setTimeout(() => {
        let sessions = document.getElementById("sessionsContainer");
        sessions.scrollLeft = sessions.scrollWidth;
      }, 100);
    },
    async editScheme(docId) {
      this.editDialog = !this.editDialog;

      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await getScheme(docId);
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.schemeToEdit = respuesta.data.data;
          console.log(this.schemeToEdit);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    addSessionToEdit() {
      const copia = this.newSessionItems;
      copia.push({
        nombre_sesion: null,
        iconoUrl: "",
        index_sesion: copia.length,
      });
      this.newSessionItems = [...copia];
      this.scroll();
    },
    scroll() {
      setTimeout(() => {
        let sessions = document.getElementById("sessions");
        sessions.scrollLeft = sessions.scrollWidth;
      }, 100);
    },
    deleteItem(list, index) {
      list.splice(index, 1);
    },
    async updateScheme() {
      this.$store.dispatch("setCargando", true);
      try {
        const sessionsMapped = [
          ...this.schemeToEdit.sesiones,
          ...this.newSessionItems,
        ].map((data, index) => {
          return {
            nombre_sesion: data.nombre_sesion,
            iconoUrl: "",
            index_sesion: index,
          };
        });
        const resuesta = await updateScheme(
          this.schemeToEdit.docId,
          this.schemeToEdit.nombre_esquema,
          this.schemeToEdit.nombre_terapia,
          this.$store.state.provider_email,
          sessionsMapped
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.resetForm();
        // this.editScheme();
        this.$store.dispatch("setCargando", false);
      }
    },
  },
  filters: {
    formatoFechaHora: function (date) {
      return moment(date).format("MM/DD/YYYY");
    },
  },
};
</script>

<style lang="scss" src="./TarjetasEsquemas.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/Terapias/TerapiasEsquema/TarjetasEsquemas/TarjetasEsquemas.vue